import { httpApi } from '@api/http.api';
import type {
    CommonTablePaginatedResponse,
    CommonTableRequest,
} from '@routes/sidebar/admin-center/___shared___/types.ts';

export type ShoreDepartmentsRequest = CommonTableRequest;

export interface ShoreDepartment {
    id: number;
    name: string | null;
    shoreDepartmentTypeId: number | null;
    shoreDepartmentTypeCode: string | null;
    email: string | null;
    phone: string | null;
    entityLocationId: number | null;
    entityLocationName: string | null;
    managerId: number | null;
    managerName: string | null;

    isInternal: boolean;
    isActive: boolean;
    isBuiltIn: boolean;
    createdAtUTC: string;
}

export interface ResultsDescription {
    [k: string]: unknown;
}

export interface ShoreDepartmentsResponse {
    data: ShoreDepartment[];
    pagination: CommonTablePaginatedResponse;
    resultsDescription: ResultsDescription;
}

export interface CreateShoreDepartmentRequest {
    name: string;
    shoreDepartmentTypeId: number;
    email: string | null;
    phone: string | null;
    entityLocationId: number | null;
    managerId: number | null;
    isInternal: boolean;
}

export type UpdateShoreDepartmentRequest = CreateShoreDepartmentRequest;

export const getApiShoreDepartments = (
    clientId: number,
    tenantAlias: string,
    payload: ShoreDepartmentsRequest,
): Promise<ShoreDepartmentsResponse> =>
    httpApi
        .post<ShoreDepartmentsResponse>(
            `admin-center/clients/${clientId}/tenants/${tenantAlias}/shore-departments/search`,
            payload,
        )
        .then(({ data }) => data);

export const createApiShoreDepartment = (
    clientId: number,
    tenantAlias: string,
    payload: CreateShoreDepartmentRequest,
): Promise<ShoreDepartment> =>
    httpApi
        .post<ShoreDepartment>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/shore-departments`, payload)
        .then(({ data }) => data);

export const updateApiShoreDepartment = (
    clientId: number,
    tenantAlias: string,
    id: number,
    payload: UpdateShoreDepartmentRequest,
): Promise<ShoreDepartment> =>
    httpApi
        .put<ShoreDepartment>(
            `admin-center/clients/${clientId}/tenants/${tenantAlias}/shore-departments/${id}`,
            payload,
        )
        .then(({ data }) => data);

export const deleteApiShoreDepartment = (clientId: number, tenantAlias: string, id: number): Promise<ShoreDepartment> =>
    httpApi
        .delete<ShoreDepartment>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/shore-departments/${id}`)
        .then(({ data }) => data);
